export interface SubItem { label: string; to: string; module?: string }
export interface MainItem { label: string; to: string; module?: string; hidden?: boolean; children: SubItem[] }

const telematics = (b: string): SubItem[] => [
  { label: "Live Map", to: `${b}/telematics` },
  { label: "Devices", to: `${b}/telematics/devices` },
  { label: "Sync Logs", to: `${b}/telematics/sync-logs` },
];
const carpool = (b: string): SubItem[] => [
  { label: "Book a Vehicle", to: `${b}/carpool` },
  { label: "Calendar", to: `${b}/carpool/calendar` },
  { label: "My Bookings", to: `${b}/carpool?view=mine` },
  { label: "Hand-overs Today", to: `${b}/carpool?view=today` },
  { label: "Usage", to: `${b}/carpool/usage` },
];

export const BO_NAV: MainItem[] = [
  { label: "Dashboard", to: "/bo", children: [
    { label: "Overview", to: "/bo" },
    { label: "Client Health", to: "/bo/dashboard/client-health" },
    { label: "Compliance Health", to: "/bo/dashboard/compliance-health" },
  ] },
  { label: "Clients", to: "/bo/clients", children: [
    { label: "All Clients", to: "/bo/clients" },
    { label: "Lead Management", to: "/bo/clients/onboarding" },
    { label: "Customer Support", to: "/bo/clients/support" },
  ] },
  { label: "Vehicle & Fleet", to: "/bo/vehicles", children: [
    { label: "Registry", to: "/bo/vehicles" },
    { label: "Service Due", to: "/bo/vehicles/service" },
    { label: "Maintenance & Repair", to: "/bo/requests" },
    { label: "Compliance", to: "/bo/compliance" },
  ] },
  { label: "Alert Center", to: "/bo/alerts", hidden: true, children: [] },
  { label: "Telematics", to: "/bo/telematics", children: telematics("/bo") },
  { label: "Car Pool", to: "/bo/carpool", children: [
    { label: "Bookings", to: "/bo/carpool" },
    { label: "Usage", to: "/bo/carpool/usage" },
    { label: "Drivers", to: "/bo/carpool/drivers" },
  ] },
  { label: "Reports", to: "/bo/reports", children: [
    { label: "Fleet Summary", to: "/bo/reports" },
    { label: "Compliance Expiry", to: "/bo/reports/compliance" },
    { label: "Driver Workload", to: "/bo/reports/drivers" },
  ] },
  { label: "Billing", to: "/bo/billing/invoices", children: [
    { label: "Invoices", to: "/bo/billing/invoices" },
    { label: "Billing Snapshot", to: "/bo/billing/snapshot" },
  ] },
  { label: "Settings", to: "/bo/settings", children: [
    { label: "Platform", to: "/bo/settings" },
    { label: "Users", to: "/bo/settings/users" },
    { label: "Branding", to: "/bo/settings/branding" },
    { label: "Billing & Pricing", to: "/bo/settings/billing" },
    { label: "Audit Trail", to: "/bo/audit" },
  ] },
];

export const CLIENT_NAV: MainItem[] = [
  { label: "Dashboard", to: "/app", children: [
    { label: "Overview", to: "/app" },
    { label: "Compliance Health", to: "/app/dashboard/compliance-health" },
  ] },
  { label: "Vehicle & Fleet", to: "/app/vehicles", module: "vehicles", children: [
    { label: "My Fleet", to: "/app/vehicles" },
    { label: "Service Due", to: "/app/vehicles/service" },
    { label: "Maintenance & Repair", to: "/app/requests" },
    { label: "Compliance", to: "/app/compliance" },
  ] },
  { label: "Alert Center", to: "/app/alerts", module: "alerts", hidden: true, children: [] },
  { label: "Telematics", to: "/app/telematics", module: "telematics", children: telematics("/app") },
  { label: "Car Pool", to: "/app/carpool", module: "carpool", children: carpool("/app") },
  { label: "Reports", to: "/app/reports", children: [
    { label: "Fleet Summary", to: "/app/reports" },
    { label: "Compliance Expiry", to: "/app/reports/compliance" },
    { label: "Driver Workload", to: "/app/reports/drivers", module: "carpool" },
  ] },
  { label: "Billing", to: "/app/billing/invoices", children: [
    { label: "Invoices", to: "/app/billing/invoices" },
    { label: "Financial Overview", to: "/app/billing" },
  ] },
  { label: "Settings", to: "/app/settings", children: [
    { label: "Organization Profile", to: "/app/settings" },
    { label: "Organizations", to: "/app/settings/organizations" },
    { label: "Users", to: "/app/settings/users" },
    { label: "Car Pool", to: "/app/settings/carpool", module: "carpool" },
    { label: "Telematics Connection", to: "/app/settings/telematics" },
    { label: "Audit Trail", to: "/app/audit", module: "audit" },
  ] },
];

export const STAFF_NAV = ["Dashboard", "Vehicle & Fleet", "Car Pool", "Telematics"];
export const OPERATOR_HIDDEN_MAIN = ["Billing"];
export const OPERATOR_HIDDEN_SUBS = ["Users", "Approvals", "Telematics Connection"];
export const STAFF_HIDDEN_SUBS = ["Devices", "Sync Logs"];

export function mainActive(item: MainItem, pathname: string, base: string): boolean {
  if (item.to === base) return pathname === base || pathname.startsWith(`${base}/dashboard`);
  if (pathname === item.to || pathname.startsWith(`${item.to}/`)) return true;
  return (item.children || []).some((c) => { const p = c.to.split("?")[0]; return p !== base && (pathname === p || pathname.startsWith(`${p}/`)); });
}

export function subActive(sub: SubItem, pathname: string, search: string): boolean {
  const [p, q = ""] = sub.to.split("?");
  if (q) return pathname === p && search.replace(/^\?/, "") === q;
  return pathname === p && search === "";
}
